import React from 'react'

interface IconProps {
  size?: number
  className?: string
  color?: string
}

// File type icons
export const FileIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  color = '#464646'
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z'
      fill={color}
    />
    <path d='M14 2V8H20' fill='white' />
  </svg>
)

export const ImageIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  color = '#464646'
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.5 13.5L11 16.51L14.5 12L19 18H5L8.5 13.5Z'
      fill={color}
    />
  </svg>
)

export const VideoIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  color = '#464646'
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5Z'
      fill={color}
    />
  </svg>
)

export const AudioIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  color = '#464646'
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M12 3V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17C6 19.21 7.79 21 10 21C12.21 21 14 19.21 14 17V7H18V3H12Z'
      fill={color}
    />
  </svg>
)

export const PdfIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  color = '#464646'
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16Z'
      fill={color}
    />
    <path
      d='M10 9H12V11H10V9ZM10 12H12V14H10V12ZM10 6H12V8H10V6ZM14 6H16V8H14V6ZM14 9H16V11H14V9ZM14 12H16V14H14V12Z'
      fill={color}
    />
  </svg>
)

export const TextIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  color = '#464646'
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z'
      fill={color}
    />
    <path d='M14 2V8H20' fill='white' />
    <path
      d='M16 13H8V11H16V13ZM16 17H8V15H16V17ZM10 9H8V7H10V9Z'
      fill='white'
    />
  </svg>
)

export const DocumentIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  color = '#464646'
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z'
      fill={color}
    />
    <path d='M14 2V8H20' fill='white' />
    <path
      d='M16 13H8V11H16V13ZM16 17H8V15H16V17ZM10 9H8V7H10V9Z'
      fill='white'
    />
  </svg>
)

export const SpreadsheetIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  color = '#464646'
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z'
      fill={color}
    />
    <path d='M14 2V8H20' fill='white' />
    <path d='M8 13H16V15H8V13ZM8 17H16V19H8V17ZM8 9H16V11H8V9Z' fill='white' />
  </svg>
)

export const PresentationIcon: React.FC<IconProps> = ({
  size = 18,
  className = '',
  color = '#464646'
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z'
      fill={color}
    />
    <path d='M14 2V8H20' fill='white' />
    <path d='M8 13H16V15H8V13ZM8 17H16V19H8V17ZM10 9H8V7H10V9Z' fill='white' />
  </svg>
)

// Icon mapping function
export const getFileTypeIcon = (
  fileType: string,
  props: IconProps = {}
): React.ReactElement => {
  const iconProps = { size: 18, className: '', color: '#464646', ...props }

  switch (fileType) {
    case 'image':
      return <ImageIcon {...iconProps} />
    case 'video':
      return <VideoIcon {...iconProps} />
    case 'audio':
      return <AudioIcon {...iconProps} />
    case 'pdf':
      return <PdfIcon {...iconProps} />
    case 'text':
      return <TextIcon {...iconProps} />
    case 'document':
      return <DocumentIcon {...iconProps} />
    case 'spreadsheet':
      return <SpreadsheetIcon {...iconProps} />
    case 'presentation':
      return <PresentationIcon {...iconProps} />
    default:
      return <FileIcon {...iconProps} />
  }
}
